// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"5b9e1e86","83":"d6381602"}[chunkId] + ".css";
};